__turbopack_context__.v({
  "chooser": "NDhQaG_chooser",
  "container": "NDhQaG_container",
  "header": "NDhQaG_header",
  "isSelected": "NDhQaG_isSelected",
  "links": "NDhQaG_links",
  "message": "NDhQaG_message",
  "messageSection": "NDhQaG_messageSection",
  "subheader": "NDhQaG_subheader",
});
